import axiosInstance from './axiosInstance';
import type { Response } from './axiosInstance';

export interface ConvertRequest {
    path: string;
    to_format: string;
    from_format?: string;
    output_path?: string;
}

export interface ConvertResult {
    output_path: string;
}

export const convertMolecule = async (params: ConvertRequest): Promise<Response<ConvertResult> | undefined> => {
    try {
        const response = await axiosInstance.post<Response<ConvertResult>>('/chemistry/convert', params);
        return response?.data;
    } catch (e) {
        return undefined;
    }
};
